import { createStore } from "effector"

export const $search = createStore("")
